export default "__VITE_ASSET__CsvtALj2__"